"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIrrigationEventsThatOverlap = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const _utils_1 = require("./_utils");
const getIrrigationEventsThatOverlap = (eventTryingToUpsert, allEvents, timezone) => {
    return allEvents.filter((eventToCheck) => {
        if (eventToCheck.eventId &&
            eventTryingToUpsert.eventId &&
            eventToCheck.eventId === eventTryingToUpsert.eventId) {
            // if event overlaps with itself, we can ignore because event is being modified
            return false;
        }
        const overlaps = (0, _utils_1.doesEventAOverlapWithEventB)({
            dateFrom: moment_timezone_1.default.tz(eventToCheck.dateFrom, timezone).seconds(0).milliseconds(0),
            dateTo: moment_timezone_1.default.tz(eventToCheck.dateTo, timezone).seconds(0).milliseconds(0),
        }, {
            dateFrom: moment_timezone_1.default.tz(eventTryingToUpsert.dateFrom, timezone).seconds(0).milliseconds(0),
            dateTo: moment_timezone_1.default.tz(eventTryingToUpsert.dateTo, timezone).seconds(0).milliseconds(0),
        });
        return overlaps;
    });
};
exports.getIrrigationEventsThatOverlap = getIrrigationEventsThatOverlap;
//# sourceMappingURL=index.js.map